export default __webpack_public_path__ + "static/media/AG.82bd0fc3.svg";